var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-layout',[_c('div',{staticClass:"d-flex justify-content-around m-5"},[_c('router-link',{staticClass:"btn btn-lg btn-info p-5",attrs:{"to":{name: 'searchForm'}}},[_vm._v("Nouvelle reprise")]),_c('router-link',{staticClass:"btn btn-lg btn-info p-5",attrs:{"to":{name: 'orders'}}},[_vm._v("Liste des reprises")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }